import {
  ConfigProcessingEnum,
  IEmailConfig,
} from 'Modules/Communication/shared/models/EmailConfig'

export interface SystemState {
  emailSettings: {
    configuration: {
      data: IEmailConfig | null
      loading: boolean
      error: any
      processing: ConfigProcessingEnum | null
      processingError: ConfigProcessingEnum | null
    }
  }
}

export const getEmailConfiguration = (state: SystemState) =>
  state.emailSettings.configuration
